"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UtilsDelete = void 0;
class UtilsDeleteError {
    constructor(message) {
        this.message = message;
    }
    static upDateWhereForDefault(message) {
        return new UtilsDeleteError(message);
    }
    static upDateWhereForRestrict(message) {
        return new UtilsDeleteError(message);
    }
    static upDateWhereForCascade(message) {
        return new UtilsDeleteError(message);
    }
    static executeUpdateForDelete(message) {
        return new UtilsDeleteError(message);
    }
}
class UtilsDelete {
    getReferencedTableName(refValue) {
        let tableName = '';
        if (refValue.length > 0) {
            const arr = refValue.split(new RegExp('REFERENCES', 'i'));
            if (arr.length === 2) {
                const oPar = arr[1].indexOf('(');
                tableName = arr[1].substring(0, oPar).trim();
            }
        }
        return tableName;
    }
    upDateWhereForDefault(withRefsNames, results) {
        let setStmt = '';
        let uWhereStmt = '';
        try {
            const key = results.key;
            const cols = [];
            for (const relItem of results.relatedItems) {
                const mVal = relItem[key];
                if (mVal !== undefined) {
                    cols.push(mVal);
                }
            }
            // Create the set statement
            for (const name of withRefsNames) {
                setStmt += `${name} = NULL, `;
            }
            setStmt += 'sql_deleted = 0';
            // Create the where statement
            uWhereStmt = `WHERE ${key} IN (`;
            for (const col of cols) {
                uWhereStmt += `${col},`;
            }
            if (uWhereStmt.endsWith(',')) {
                uWhereStmt = uWhereStmt.slice(0, -1);
            }
            uWhereStmt += ');';
        }
        catch (error) {
            const msg = error.message ? error.message : error;
            throw UtilsDeleteError.upDateWhereForDefault(msg);
        }
        return { setStmt, uWhereStmt };
    }
    upDateWhereForRestrict(results) {
        try {
            const setStmt = '';
            const uWhereStmt = '';
            if (results.relatedItems.length > 0) {
                const msg = 'Restrict mode related items exist, please delete them first';
                throw UtilsDeleteError.upDateWhereForRestrict(msg);
            }
            return { setStmt, uWhereStmt };
        }
        catch (error) {
            const msg = error.message ? error.message : error;
            throw UtilsDeleteError.upDateWhereForRestrict(msg);
        }
    }
    upDateWhereForCascade(results) {
        let setStmt = '';
        let uWhereStmt = '';
        try {
            const key = results.key;
            const cols = [];
            for (const relItem of results.relatedItems) {
                const mVal = relItem[key];
                if (mVal !== undefined) {
                    cols.push(mVal);
                }
            }
            setStmt += 'sql_deleted = 1';
            // Create the where statement
            uWhereStmt = `WHERE ${key} IN (`;
            for (const col of cols) {
                uWhereStmt += `${col},`;
            }
            if (uWhereStmt.endsWith(',')) {
                uWhereStmt = uWhereStmt.slice(0, -1);
            }
            uWhereStmt += ');';
        }
        catch (error) {
            const msg = error.message ? error.message : error;
            throw UtilsDeleteError.upDateWhereForCascade(msg);
        }
        return { setStmt, uWhereStmt };
    }
    getCurrentTimeAsInteger() {
        const currentTime = Math.floor(Date.now() / 1000);
        return currentTime;
    }
    checkValuesMatch(array1, array2) {
        for (const value of array1) {
            if (!array2.includes(value)) {
                return false;
            }
        }
        return true;
    }
}
exports.UtilsDelete = UtilsDelete;
//# sourceMappingURL=utilsDelete.js.map